<template functional>
    <div class="f fj-c fa-c pr sm-r-l">
        <div class="f fh fa-c br-c pr oh" style="height: 8rem; width: 8rem;">
            <div class="el-stencil br-c dw-10 dh-10"></div>
            <div class="sm-xs pa-f br-c c-el-panel-bg"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'mead-score-stencil',
    functional: true,
};
</script>
